import gql from 'graphql-tag';

// Queries
export const POSTING_QUERY = gql`
  query searchPostingByUuid($uuid: String!) {
    searchPostingByUuid(uuid: $uuid) {
      id
      uuid
      title
      email
      location
      experienceLevel
      hourlyRateLow
      hourlyRateHigh
      yearlySalaryLow
      yearlySalaryHigh
      skills
      requirements
      responsibilities
      category{
        id
      }
      userProfile {
        id
      }
      company {
        id
        name
        logoUrl
      }
    }
  }
`;

export const POSTINGS_QUERY = gql`
  query searchPostingsByTitleLocation($title: String, $location: String, $pageNumber: Int, $postPerPage: Int) {
    searchPostingsByTitleLocation(title: $title, location: $location, pageNumber: $pageNumber, postPerPage: $postPerPage) {
      uuid
      title
      location
      hourlyRateLow
      hourlyRateHigh
      yearlySalaryLow
      yearlySalaryHigh
      skills
      experienceLevel
      category {
        name
      }
      company {
        name
        logoUrl
      }
    }
  }
`;

export const USER_POSTINGS_QUERY = gql`
  query searchPostingsByUserToken($token: String!) {
    searchPostingsByUserToken(token: $token) {
      uuid
      title
      location
      hourlyRateLow
      hourlyRateHigh
      yearlySalaryLow
      yearlySalaryHigh
      skills
      experienceLevel
      category {
        name
      }
      company {
        name
        logoUrl
      }
    }
  }
`;

export const POSTING_FORM_DATA_QUERY = gql`
  {
    allCompanies {
      id
      name
    }
    allCategories{
      id
      name
    }
  }
`;


// Mutations

export const MUTATE_POSTING = gql`
  mutation (
    $postingId: Int,
    $categoryId: Int,
    $companyId: Int,
    $token: String,
    $title: String,
    $email: String,
    $location: String,
    $experienceLevel: String,
    $requirements: String,
    $responsibilities: String,
    $yearlySalaryLow: Int,
    $yearlySalaryHigh: Int,
  ){
    createUpdatePosting(postingInput: {
      token: $token,
      postingId: $postingId,
      categoryId: $categoryId,
      companyId: $companyId,
      title: $title,
      email: $email,
      location: $location,
      experienceLevel: $experienceLevel,
      requirements: $requirements,
      responsibilities: $responsibilities,
      yearlySalaryLow: $yearlySalaryLow,
      yearlySalaryHigh: $yearlySalaryHigh,
    }) {
      status
      code
      message
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/postings/graphql.js